/**
 * Origins embedded in Firebase Auth email action / continue URLs.
 * Override with VITE_AUTH_CONTINUE_ORIGIN; never use localhost (email clients cannot redirect back).
 */
const DEV_AUTH_ORIGIN = 'https://tenteams-dev.web.app';
const PROD_AUTH_ORIGIN = 'https://tenteams.co.uk';

/** HTTPS origin baked into Firebase email action links (never localhost — Mail can't redirect back). */
export function getAuthContinueOrigin(): string {
  const override = import.meta.env.VITE_AUTH_CONTINUE_ORIGIN as string | undefined;
  if (override?.trim()) {
    return override.replace(/\/$/, '');
  }
  if (import.meta.env.VITE_FIREBASE_ENV === 'development') {
    return DEV_AUTH_ORIGIN;
  }
  return PROD_AUTH_ORIGIN;
}

export function buildAuthContinueUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getAuthContinueOrigin()}${normalizedPath}`;
}
